import axios from "../request";
//post
export const signIn = (data) => {
  return axios({
    url: "/login/signIn",
    method: "post",
    data
  });
};
export const getUserinfo = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/getCurrentUser",
    method: "post",
    data
  });
};
export const verificationSignIn = (data) => {
  return axios({
    url: "/login/verificationSignIn",
    method: "post",
    data
  });
};
export const getCompanyList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/getCurrentCompanies",
    method: "post",
    data
  });
};
export const sendVerificationCode = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-message-app/sms/sendVerificationCode",
    method: "post",
    data
  });
};
export const getRoleList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/queryMenuByPermission",
    method: "post",
    data
  });
};

//检验验证码
export const checkVerificationCode = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-message-app/sms/checkVerificationCode",
    method: "post",
    data
  });
};
//权限
export const getMenuRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRole/getMenuRole",
    method: "post",
    data
  });
};
//获取环信token
export const getNotifyToken = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-message-app/message/easemobAppToken",
    method: "post",
    data
  });
};
//职业身份
export const dutyTypeDict = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/dict/dutyTypeDict",
    method: "post",
    data
  });
};

//查询已有认证企业
export const queryAuthComByCurrentUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/queryAuthComByCurrentUser",
    method: "post",
    data
  });
};
//校验手机号
export const checkMobile = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/checkMobile",
    method: "post",
    data
  });
};
//更新密码
export const forgetPassword = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/forgetPassword",
    method: "post",
    data
  });
};
//注册
export const register = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/register",
    method: "post",
    data
  });
};
//已注册但是第一次登录系统
export const updateFirstRegisterUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/updateFirstRegisterUser",
    method: "post",
    data
  });
};
//更新密碼
export const updatePassword = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/updatePassword",
    method: "post",
    data
  });
};
//更新手机号
export const updateMobile = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/updateMobile",
    method: "post",
    data
  });
};

//获取验证图片  以及token
export const reqGet = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-thirdParty-app/dynamicCaptcha/get",
    method: "post",
    data,
    header: { AppSecretKey: "XtJMTI2e3fRChHA8vg7rUSN4dZKyD0FWuOY6" }
  });
};

//滑动或者点选验证
export const reqCheck = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-thirdParty-app/dynamicCaptcha/check",
    method: "post",
    data,
    header: { AppSecretKey: "XtJMTI2e3fRChHA8vg7rUSN4dZKyD0FWuOY6" }
  });
};

//检索企业
export const retrievalCompany = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/retrievalCompany",
    method: "post",
    data
  });
};
//天眼查
export const skySearch = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-thirdParty-app/company/search",
    method: "post",
    data
  });
};
//天眼查详情
export const skySearchBaseInfo = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-thirdParty-app/company/baseInfo/v2",
    method: "post",
    data
  });
};
//查询行业一级菜单
export const queryDictOneLevel = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/dict/queryDictOneLevel",
    method: "post",
    data
  });
};
//查询企业规模
export const queryDictContainRelation = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/dict/queryDictContainRelation",
    method: "post",
    data
  });
};
//获取客服电话
export const customerServicePhone = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/configure/customerServicePhone",
    method: "get",
    data
  });
};
//验证用户是否处于体验版
export const checkUserExperience = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/expUser/checkUserExperience",
    method: "get",
    data
  });
};
